import * as React from 'react';
import { DropdownMenu } from '../../DropdownMenu';

export interface AdminHeaderProps {

}

export default ({ }: AdminHeaderProps) => (
  <div className="header-container">
    <img src={require('../img/Loveland_logo.svg')} className="loveland-logo" />
    <DropdownMenu
      title={<img src={require('../img/admin.svg')} className="admin-logo" />}
      options={[{
        title: 'Logout',
        onClick: () => window.location.pathname = '/auth/logout',
      }]}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Admin/components/Header.tsx